import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHint = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#pet__clip0_1207_2180)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#FFDC48",
			fillRule: "evenodd",
			d: "M12.8608 3.48817C12.4737 2.83345 11.5263 2.83345 11.1392 3.48817L8.85596 7.34981C8.71368 7.59043 8.47718 7.76053 8.20379 7.81884L3.79358 8.75961C3.03945 8.92048 2.74345 9.8383 3.26151 10.4095L6.25197 13.7064C6.4427 13.9166 6.53506 14.1981 6.50604 14.4804L6.05243 18.8937C5.97425 19.6544 6.74397 20.2178 7.44538 19.9133L11.6018 18.109C11.8558 17.9987 12.1442 17.9987 12.3982 18.109L16.5546 19.9133C17.256 20.2178 18.0258 19.6544 17.9476 18.8937L17.494 14.4804C17.4649 14.1981 17.5573 13.9166 17.748 13.7064L20.7385 10.4095C21.2566 9.8383 20.9606 8.92048 20.2064 8.75961L15.7962 7.81884C15.5228 7.76053 15.2863 7.59043 15.144 7.3498L12.8608 3.48817ZM12.5728 15.6795C14.0588 15.4803 14.8851 14.6194 14.8851 13.4455C14.8851 11.9911 13.4852 11.5317 12.3185 11.1489C11.4852 10.8754 10.7708 10.641 10.7708 10.1108C10.7708 9.52595 11.302 9.24892 12.0832 9.24892C12.7915 9.24892 13.4269 9.51569 14.031 10.0082L14.8018 9.10527C14.2034 8.57647 13.5232 8.16486 12.5728 8.04988V6.74535H11.552V8.04259C10.1816 8.19284 9.30216 9.01153 9.30216 10.2134C9.30216 11.6153 10.6581 12.0738 11.8132 12.4643C12.6701 12.754 13.4164 13.0064 13.4164 13.5789C13.4164 14.174 12.9373 14.4921 11.8853 14.4921C11.1145 14.4921 10.3229 14.2253 9.67713 13.6609L8.98968 14.687C9.61477 15.2937 10.6861 15.6367 11.552 15.7089V17.0059H12.5728V15.6795Z",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_1207_2180",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgHint);
export default ForwardRef;
